import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    errorMessage: undefined,
    notification: null,
    showModal: false,
};

const notificationSlice = createSlice({
    name: "Notifications",
    initialState,
    reducers: {
        getResponseNotificationRequest(state) {
            state.errorMessage = undefined;
            state.notification = undefined;
            state.loading = true;
            state.showModal = true;
        },
        getResponseNotificationSuccess(state, action) {
            state.notification = action.payload;
            state.loading = false;
        },
        getResponseNotificationFailure(state, action) {
            state.errorMessage = action.payload;
            state.loading = false;
        },
        getPublicResponseNotificationFailure(state) {
            state.errorMessage = undefined;
            state.notification = undefined;
            state.loading = false;
            state.showModal = false;
        },
        getPlatformNotificationsRequest(state) {
            state.platformNotificationsLoading = true;
            state.platformNotificationsErrorMessage = null;
        },
        getPlatformNotificationsSuccess(state, action) {
            state.platformNotificationsLoading = false;
            state.platformNotifications = action.payload;
        },
        getPlatformNotificationsFailure(state, action) {
            state.platformNotificationsLoading = false;
            state.platformNotifications = null;
            state.platformNotificationsErrorMessage = action.payload;
        },
        dismissPlatformNotificationRequest(state, action) {
            state.dismissPlatformNotificationsLoading = true;

            if (action.payload) {
                // We are removing the notification straight away for a better UX
                let tempNotifications = [...state.platformNotifications];
                const index = tempNotifications.findIndex((n) => n.externalUUID === action.payload);
                if (index !== -1) {
                    tempNotifications.splice(index, 1);
                    state.platformNotifications = tempNotifications;
                }

                state.platformNotifications = tempNotifications;
            }
        },
        dismissPlatformNotificationSuccess(state, action) {
            state.dismissPlatformNotificationsLoading = false;
        },
        dismissPlatformNotificationFailure(state, action) {
            state.dismissPlatformNotificationsLoading = false;
            state.dismissPlatformNotificationsErrorMessage = action.payload;
        },

        clearNotifications() {
            return initialState;
        },
    },
});

export default notificationSlice;
